import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const LanguageSelect = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('en-us');

  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value;
    setSelectedLanguage(newLanguage);
    if(newLanguage === 'en-us') {
      window.location.href = `/`;
    } else {
      window.location.href = `/${newLanguage}/`;
    }
  };

  useEffect(() => {
    setSelectedLanguage(window.TMW.localization.localeString);
  }, []);

  return (
    <div className='pt-[48px]'>
      <select value={selectedLanguage} className='select' onChange={handleLanguageChange}>
        <option value="en-ca">{ window.TMW.Strings?.locales?.ca }</option>
        <option value="fr-ca">{ window.TMW.Strings?.locales?.cafr }</option>
        <option value="en-us">{ window.TMW.Strings?.locales?.en }</option>
      </select>
    </div>
  );
};

export default LanguageSelect;
